import React, { useState,useEffect } from 'react';
import ModalPassifDescription from '../modal/ModalPassifDescription';
import ModalNouveauPassif from '../modal/ModalNouveauPassif';

const Passives = ({ passives, idPerso,token }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalNewOpen, setIsModalNewOpen] = useState(false);
  const [selectedPassive, setSelectedPassive] = useState(null);
  const [modif, setModif] = useState(false);
  const valeur = ["Malus majeur", "Malus", "Neutre", "Bonus", "Bonus Majeur"]
  useEffect(() => {
    if(modif) {
      setIsModalNewOpen(true)
    }else{
      
      setSelectedPassive(null)
    }
}, [modif]);
  
  
  return (
    <div className="table__wrap table_wrap">
      <table className="table">
        <tbody>
          {passives.map((element, index) => (

            <tr className="table__row1" key={index} onClick={() => { setIsModalOpen(!isModalOpen); setSelectedPassive(element) }} >
              <td className="table__account table__cell">
                <div className="table__account-content "><span className="table__account-number">{element.description}</span> <span className="table__account-name tab">{element.nom}</span>
                </div>
              </td>
              <td className="table__lvl table__cell  u-font-mono"><span className="num_negative">{valeur[element.valeur + 2]}</span></td>
            </tr>
          ))}
          <tr className="table__row1_button">
            <td className='center' colSpan="4">
              <button
                className='pushable ajout_tabs'
                onClick={() => { setIsModalNewOpen(!isModalNewOpen) }}
              >
                <span id="Force" className="front front_add" >
                  Ajout nouveau passif
                </span>
              </button>
            </td>
          </tr>
        </tbody>
        <tfoot>
        </tfoot>
      </table>
      <ModalPassifDescription
        isOpen={isModalOpen}
        passive={selectedPassive}
        setModif={setModif}
        setOpen={setIsModalOpen}
        token={token}
      />
      <ModalNouveauPassif
        isOpen={isModalNewOpen}
        idPerso={idPerso}
        passif={modif ? selectedPassive : null}
        setModif={setModif}
        setOpen={setIsModalNewOpen}
        token={token}
      />
    </div>
  );
};

export default Passives;


